import { Link as GatsbyLink } from "gatsby";
import { Link, useI18next } from "gatsby-plugin-react-i18next";
import React from "react";

interface Props {
  language: string;
  className?: string;
}

// Legal pages live at /disclaimers/:lang/:slug (language inside the path, not as a /de/ prefix),
// so switching language there has to link to the matching disclaimer page instead of prefixing the path.
const disclaimerPattern = /^\/disclaimers\/(?:[a-z]{2}\/)?([\w-]+)\/?$/;

export const LanguageLink: React.FC<Props> = ({ language, children, ...rest }) => {
  const { originalPath } = useI18next();
  const disclaimer = originalPath.match(disclaimerPattern);

  if (disclaimer) {
    return (
      <GatsbyLink to={`/disclaimers/${language}/${disclaimer[1]}/`} {...rest}>
        {children}
      </GatsbyLink>
    );
  }

  return (
    <Link to={originalPath} language={language} {...rest}>
      {children}
    </Link>
  );
};
